import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { create } from 'zustand';

import { AVADialog } from './AVADialog';

interface ConfirmOptions {
    title: string;
    message: string;
    onConfirm: () => void;
}

interface ConfirmStore extends ConfirmOptions {
    open: boolean;
    confirm: (options: ConfirmOptions) => void;
    close: () => void;
}

const CLOSED: Omit<ConfirmStore, 'confirm' | 'close'> = {
    open: false,
    title: '',
    message: '',
    onConfirm: () => undefined,
};

const useConfirmStore = create<ConfirmStore>()((set) => ({
    ...CLOSED,
    confirm: (options) => set({ ...options, open: true }),
    close: () => set(CLOSED),
}));

export const useConfirmDialog = () => ({
    confirm: useConfirmStore((s) => s.confirm),
});

export const ConfirmDialogHost = () => {
    const { open, title, message, onConfirm, close } = useConfirmStore();

    const handleConfirm = () => {
        onConfirm();
        close();
    };

    return (
        <AVADialog
            open={open}
            title={title}
            onClose={close}
            draggable={false}
            disableBackdropClose
            maxWidth='xs'
            actionsSx={{ justifyContent: 'center', gap: '1rem' }}
            actions={
                <>
                    <Button
                        variant='contained'
                        startIcon={<CheckIcon />}
                        onClick={handleConfirm}
                        sx={{ backgroundColor: '#03659a' }}
                    >
                        YES
                    </Button>
                    <Button
                        variant='contained'
                        startIcon={<CloseIcon />}
                        onClick={close}
                        sx={{ backgroundColor: '#03659a' }}
                    >
                        NO
                    </Button>
                </>
            }
        >
            <p>{message}</p>
        </AVADialog>
    );
};
